"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["EMPTY_LAYOUT"] = "EMPTY_LAYOUT";
    LayoutType["DEFAULT_LAYOUT"] = "DEFAULT_LAYOUT";
})(LayoutType || (exports.LayoutType = LayoutType = {}));
//# sourceMappingURL=route.decl.js.map